(function ($) {
    $(window).load(function () {
        /**
         * tile questions
         */
        $('.collapse_container .contenu_collapse').hide();

        $('.collapse_container').each(function () {
            $(this).find('.wrapper > .texte').click(function () {
                $('.collapse_container.active').not($(this).closest('.collapse_container')).removeClass('active').find('.contenu_collapse').slideUp('fast');
                $(this).closest('.collapse_container').toggleClass('active').find('.contenu_collapse').slideToggle('fast');
            });
        });
    });
})(jQuery);